export default {
    man: {
        description: 'clears the current console view',
    },
    run: ({ clear, exit }) => {
        exit();
        clear();
    },
};
